import { render, staticRenderFns } from "./PageTitle.vue?vue&type=template&id=692e3361&scoped=true&"
import script from "./PageTitle.vue?vue&type=script&lang=js&"
export * from "./PageTitle.vue?vue&type=script&lang=js&"
import style0 from "./PageTitle.vue?vue&type=style&index=0&id=692e3361&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "692e3361",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('692e3361')) {
      api.createRecord('692e3361', component.options)
    } else {
      api.reload('692e3361', component.options)
    }
    module.hot.accept("./PageTitle.vue?vue&type=template&id=692e3361&scoped=true&", function () {
      api.rerender('692e3361', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/PageTitle.vue"
export default component.exports